module.exports = __webpack_public_path__ + "img/en.c9213f1d.svg";